import React, { useContext, useEffect, useState } from "react";
import { MilestoneBenefitsContext } from "../../context/MilestoneBenefitsContext";

const BrandModalContent = ({ brand, level, handleClose }) => {
  const { milestone_benefits, getMilestoneBenefits } = useContext(MilestoneBenefitsContext);
  const [brandLevel, setBrandLevel] = useState(null);

  useEffect(() => {
    if (!milestone_benefits) {
      getMilestoneBenefits();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (milestone_benefits && brand && level) {
      const brandId = brand.brand_id;
      const milestoneBenefit = milestone_benefits.find(
        (mb) => mb.brand_id === brandId && mb.milestone_id === level
      );
      setBrandLevel(milestoneBenefit || null);
    }
  }, [milestone_benefits, brand, level]);

  return (
    <div className="brands-features__slide align-items-center">
      <div className="bg-white" style={{ borderRadius: "8px" }}>
        <div className="bg-rewards-gradient text-white h-100 slide__container">
          <div className="row w-100 justify-content-end">
            <button
              type="button"
              className="btn-close"
              onClick={handleClose}
            ></button>
          </div>

          <div className="row flex-column align-items-center">
            <h2 className="title font-dm-sans">BENEFICIOS</h2>
          </div>

          <div className="row align-items-center mb-5">
            <div className="col-12 col-md-6 text-center">
              {brand === "TBM" && (
                <img
                  alt="tbm logo"
                  width={50}
                  height={50}
                  src="/img/tbm-icon.png"
                />
              )}
              {brand.file?.src && (
                <div
                  className="bg-white m-auto mb-4 d-flex align-items-center justify-content-center"
                  style={{
                    width: "200px",
                    height: "200px",
                    borderRadius: "50%",
                  }}
                >
                  <img
                    alt="reward brand"
                    src={brand.file.src}
                    className="w-100 d-block m-auto"
                    style={{ maxWidth: "300px" }}
                  />
                </div>
              )}
              <p
                onClick={() => {
                  if (brand?.instagram) {
                    const instagramCleaned = brand.instagram.replace(/@/g, "");
                    window.open(
                      `https://www.instagram.com/${instagramCleaned}`,
                      "_blank"
                    );
                  }
                }}
                className="instagram text-white font-dm-sans text-center cursor-pointer mb-3"
              >
                <i className="fab fa-instagram me-2 text-white" />
                {brand?.instagram}
              </p>
              {brand.website && (
                <a
                  target="_blank"
                  href={brand.website}
                  rel="noopener noreferrer"
                  className="instagram text-white d-block font-dm-sans text-center cursor-pointer mb-3 no-decoration"
                >
                  <i className="fas fa-globe me-2 text-white" />
                  {brand?.website.replace("https://", "")}
                </a>
              )}
            </div>
            <div className="col-12 col-md-6">
              <p className="feat font-dm-sans my-auto w-max-content">
                BENEFICIOS
              </p>

              <p>{brandLevel?.benefit ? brandLevel.benefit : "-"}</p>

              <p className="feat font-dm-sans my-auto w-max-content">
                APLICACIÓN
              </p>

              <p>{brandLevel?.application ? brandLevel.application : "-"}</p>

              <p className="feat font-dm-sans my-auto w-max-content">
                RESTRICCIONES
              </p>

              <p>{brandLevel?.restrictions ? brandLevel.restrictions : "-"}</p>

              <p className="feat font-dm-sans my-auto w-max-content">
                VIGENCIA
              </p>

              <p>{brandLevel?.expiration ? brandLevel.expiration : "-"}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BrandModalContent;
